// import KakaoLogin from "react-kakao-login";
// 
// const KakaoLoginButton = () => {
// 
//     const kakaoClientId = '1f691e80a1cc3d4ae6df91fd5dd2434d'
//     const kakaoOnSuccess = async (data) => {
//         console.log(data)
//         const idToken = data.response.access_token  // 엑세스 토큰 백엔드로 전달
//         console.log(idToken)
//     }
//     const kakaoOnFailure = (error) => {
//         console.log(error);
//     };
//     return (
//         <>
//             <KakaoLogin
//                 token={kakaoClientId}
//                 onSuccess={kakaoOnSuccess}
//                 onFail={kakaoOnFailure}
//             />
//         </>
//     )
// }
// 
// export default KakaoLoginButton

import React, { useState } from 'react';
import KakaoLogin from "react-kakao-login";
import { useNavigate } from 'react-router-dom';
import { SERVER_BASE_URL } from '../constants';

import './LoginButtons.css';

const KakaoLoginButton = () => {
    const kakaoClientId = process.env.REACT_APP_KAKAO_CLIENT_ID;
    const apiKey = process.env.REACT_APP_X_API_KEY;
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false); // 초기에는 로딩 중이 아님

    const kakaoOnSuccess = async (data) => {
        setLoading(true); // 로딩 시작

        const accessToken = data.response.access_token;
        console.log("Access Token:", accessToken);

        try {
            const response = await fetch("https://kapi.kakao.com/v2/user/me", {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            });

            const userData = await response.json();
            const userId = userData['kakao_account']['email'] + '-K';
            console.log(userId);

            const signInResponse = await fetch(`${SERVER_BASE_URL}/sign-in`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': apiKey,
                },
                body: JSON.stringify({ 'user_id': userId }),
            });

            setLoading(false); // 로딩 종료

            if (signInResponse.ok) {
                const data = await signInResponse.json();
                console.log('Success:', data);
                const authToken = data.authorization_token;
                localStorage.setItem('authorization_token', authToken);
                navigate('/main');
            } else if (signInResponse.status === 404) {
                alert('회원정보가 존재하지 않습니다.');
                throw new Error('User not found.');
            } else {
                throw new Error('Network response was not ok.');
            }
        } catch (error) {
            setLoading(false); // 로딩 종료
            console.error("Error fetching user data:", error);
        }
    };

    const kakaoOnFailure = (error) => {
        setLoading(false); // 로딩 종료
        console.log(error);
    };

    return (
        <div className="login-button kakao-login-button"> {/* 클래스 이름 추가 */}
            <KakaoLogin
                token={kakaoClientId}
                onSuccess={kakaoOnSuccess}
                onFail={kakaoOnFailure}
            />
            {isLoading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}
        </div>
    );
};

export default KakaoLoginButton;
